import { render, staticRenderFns } from "./KT-Related.vue?vue&type=template&id=261cc26e&lang=pug&"
import script from "./KT-Related.vue?vue&type=script&lang=js&"
export * from "./KT-Related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports